/* eslint-disable jsx-a11y/control-has-associated-label */
import PassivePagination from 'components/Pagination';
import SearchableHeader from 'components/SearchableHeader';
import SortableHeader from 'components/SortableHeader';
import useSortedSearch from 'hooks/useSortedSearch';
import UserResource from 'models/users/resource';
import UserSearcher from 'models/users/searcher';
import React, { useMemo, useState } from 'react';
import { Table } from 'react-bootstrap';
import * as Contexts from './Context';
import Create from './Create';
import Delete from './Delete';
import UserRow from './Row';

type Props = {
  values: UserResource[]
};

export const AccessTable = ({ values }: Props) => {
  const [selection, setSelection] = useState<Contexts.SelectionValue>({});
  const searcher = useMemo(() => new UserSearcher(), []);
  const [sorted, sort, search, setSort, setSearch] = useSortedSearch(values, searcher, searcher, {
    type: 'email',
    asc: true,
  });

  const selectionValue: Contexts.SelectionContextValue = useMemo(() => ({
    selection,
    setSelection,
  }), [selection, setSelection]);

  return (
    <div className="uploads">
      <Contexts.SelectionContext.Provider value={selectionValue}>
        <Delete />
        <Table>
          <thead>
            <tr>
              <SearchableHeader value={search} types={['email']} onSearch={setSearch} />
              <th colSpan={2} />
            </tr>
            <tr>
              <SortableHeader value={sort} type="email" onChange={setSort}>
                Email
              </SortableHeader>
              <th>
                <Create />
              </th>
            </tr>
          </thead>
          <tbody>
            <PassivePagination
              items={sorted}
              renderItem={(item) => (
                // eslint-disable-next-line max-len
                <UserRow key={item.id} value={item} />
              )}
            />
          </tbody>
        </Table>
      </Contexts.SelectionContext.Provider>
    </div>
  );
};

export default AccessTable;
